module.exports = __WEBPACK_EXTERNAL_MODULE_24__;


//////////////////
// WEBPACK FOOTER
// external {"root":["Rx","Observable"],"commonjs":"rxjs/observable/fromPromise","commonjs2":"rxjs/observable/fromPromise","amd":"rxjs/observable/fromPromise"}
// module id = 24
// module chunks = 0 1